import ToggleButton from "@rio-cloud/rio-uikit/ToggleButton"
import { FormattedMessage } from "react-intl"
import * as React from "react"

interface TransportOrderAdditionalFiltersToggleProps {
    isOpen: boolean
    activeFilterCount: number
    onToggle: () => void
}

export const TransportOrderAdditionalFiltersToggle = (
    props: TransportOrderAdditionalFiltersToggleProps
): React.ReactElement => {
    const { isOpen, activeFilterCount, onToggle } = props

    return (
        <div className="indicated-button">
            <ToggleButton
                active={isOpen}
                iconName="icon-filter"
                onClick={onToggle}
                aria-expanded={isOpen}
                aria-controls="transport-order-filter-panel"
            >
                <FormattedMessage id="transportOrder.overview.toolbar.filter.label"/>
            </ToggleButton>
            {activeFilterCount > 0 && (
                <span className="badge badge-primary badge-indicator badge-indicator-border">
                    {activeFilterCount}
                </span>
            )}
        </div>
    )
}
